import { Component } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { environment } from 'src/app/environments/environment';
import { AppType } from 'src/app/model/app-type.model';
import { RemoteKind } from '../../model/remote-access.model';
import { AppState } from '../../store';
import * as fromAgreement from '../../store/agreements/agreements.reducer';
import * as fromAttachments from '../../store/attachments/attachments.reducer';
import * as fromRemote from '../../store/remote/remote.reducer';
import { CheckDocumentsComponent } from '../modals/check-documents/check-documents.component';

@Component({
  selector: 'app-agreements',
  templateUrl: './agreements.component.html',
  styleUrls: ['./agreements.component.scss'],
})
export class AgreementsComponent {
  isAllDownloaded$ = this.store.select(fromAttachments.selectAttachmentsIsAllDownloaded);
  isAnyRequiredAgreement$ = this.store.select(fromAgreement.selectIsAnyRequiredAgreement);
  isAppDirect = environment.app === AppType.Direct;
  remoteKind$ = this.store.select(fromRemote.selectRemoteKind);

  modal: NxModalRef<CheckDocumentsComponent, any> | undefined;

  constructor(private store: Store<AppState>, private dialogService: NxDialogService) {}

  get remoteKindSuffix$() {
    return this.remoteKind$.pipe(map((remoteKind) => (remoteKind === RemoteKind.TravelAgency ? '-travelAgency' : '')));
  }

  showModal(): void {
    this.modal = this.dialogService.open(CheckDocumentsComponent, {
      panelClass: 'check-documents-modal',
      showCloseIcon: true,
      maxWidth: '1472px',
      width: '100%',
    });
  }
}
